module.exports = __webpack_public_path__ + "img/img1.af11353e.png";